import React from 'react';
import './Input.scss';

const Input = (props, ref) => {
    const classes = "Input " + props.className;
    const onKeyDown = props.onKeyDown;
    const value = props.valueInput

    return (

        <div  className={classes}>
            <input 
            type={props.type}
            name={props.name}
            placeholder={props.placeholder} 
            ref={ref}  
            className={props.classNameInput}
            onKeyDown={onKeyDown}
            value={value}
            />
            {props.children}
            </div>
    );
}



const forwardRefInput = React.forwardRef(Input)
export default forwardRefInput ;
